<script lang="ts">
    import {getLocalization} from 'core/svelte-context/context';
    import KpGenericTable from 'shared/ui-widgets/table/KpGenericTable.svelte';
    import {pipe} from 'core/utils';
    import {loc} from 'shared/utils/pipes';
    import type {Rec} from 'typings/portaro.be.types';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';
    import {Subkind} from 'shared/constants/portaro.constants';

    export let record: Rec;

    const localize = getLocalization();

    function booleanColor(value: boolean) {
        return value ? 'var(--success-green)' : 'var(--danger-red)';
    }
</script>

<KpGenericTable additionalClasses="record-information-table"
                stripedRows
                hoverRows
                condensed
                horizontallyDivided>

    <svelte:fragment slot="body">
        <tr>
            <td>{localize(/* @kp-localization commons.Active */ 'commons.Active')}</td>
            <td style="color: {booleanColor(record.active)}">
                <UIcon icon="{record.active ? 'check' : 'cross'}"/>
            </td>
        </tr>

        <tr>
            <td>{localize(/* @kp-localization commons.Deleted */ 'commons.Deleted')}</td>
            <td style="color: {booleanColor(record.deleted)}">
                <UIcon icon="{record.deleted ? 'check' : 'cross'}"/>
            </td>
        </tr>

        <tr>
            <td>{localize(/* @kp-localization commons.fond */ 'commons.fond')}</td>
            <td>{record.fond.id} - {pipe(record.fond, loc())}</td>
        </tr>

        {#if record.type === Subkind.SUBKIND_DOCUMENT}
            <tr>
                <td>{localize(/* @kp-localization record.Periodical */ 'record.Periodical')}</td>
                <td style="color: {booleanColor(record.periodical)}">
                    <UIcon icon="{record.periodical ? 'check' : 'cross'}"/>
                </td>
            </tr>

            <tr>
                <td>{localize(/* @kp-localization record.CanHaveExemplars */ 'record.CanHaveExemplars')}</td>
                <td style="color: {booleanColor(record.exemplarable)}">
                    <UIcon icon="{record.exemplarable ? 'check' : 'cross'}"/>
                </td>
            </tr>

            <tr>
                <td>{localize(/* @kp-localization record.CanHaveVolumes */ 'record.CanHaveVolumes')}</td>
                <td style="color: {booleanColor(record.volumeable)}">
                    <UIcon icon="{record.volumeable ? 'check' : 'cross'}"/>
                </td>
            </tr>
        {/if}

        <tr>
            <td>{localize(/* @kp-localization record.Cover */ 'record.Cover')}</td>
            <td>
                {#if record.cover?.id}
                    {record.cover.id} - {record.cover.filename}
                {:else}
                    {localize(/* @kp-localization commons.Universal */ 'commons.Universal')}
                {/if}
            </td>
        </tr>
    </svelte:fragment>
</KpGenericTable>

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    tr {
        &:first-child > td {
            border-top: none;
        }

        & > td {
            padding: @table-cell-padding @padding-small-horizontal !important;

            &:last-child {
                font-weight: 500;
            }
        }
    }

    :global(.record-information-table) {
        table-layout: fixed;
        width: 100%;
        border-radius: @border-radius-base;
        overflow: hidden;
    }
</style>